import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { Row, Column } from 'react-foundation';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Icon } from '../../components/Icon';
import { Link } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Matrix } from '../../components/Matrix';
import { Error } from '../../components/Error';
import * as simActions from '../../modules/sims/actions';
import * as customerActions from '../../modules/customer/actions';
import * as globalActions from '../../modules/global/actions';
import { makeSelectFetching, makeSelectSims, makeSelectCurrentOrder, makeSelectUpdateOrderFinished } from '../../modules/sims/selectors';
import _ from 'lodash';
import { selectCustomerData } from '../../modules/customer/selectors';
import { selectErrors } from '../../modules/global/selectors';
import { getAccountId } from '../../utils/helpers';
import { ConfirmModal } from '../../components/ConfirmModal';
import { gaB2BChangeOrder } from '../../utils/analytics';
import { B2B2SalesArguments } from './B2B2SalesArguments';

const Center = styled.div`
	text-align: center;
	margin: auto;

	#data-alert {
		text-align: left;
		margin: auto;
		max-width: 27rem;
		margin-top: 1rem;
		margin-bottom: 1.2rem;
	}

	#confirm-header {
		font-size: 2rem;
		margin-top: 2.2rem;
	}
`;

const Container = styled.div`
	text-align: left;
	margin-left: 2rem;

	p {
		margin-top: 0;
		padding-top: 0px;
	}
`;

const SquareRed = styled.div`
	float: left;
	width: 24px;
	height: 24px;
	margin: 5px;
	border: 1px solid rgba(0, 0, 0, 0.2);
	background-color: red;
`;

const SquareGrey = styled.div`
	float: left;
	width: 24px;
	height: 24px;
	margin: 5px;
	border: 1px solid rgba(0, 0, 0, 0.2);
	background-color: #969696;
`;

const LegendItem = styled.div`
	margin-bottom: 1em;
`;

const GreyText = styled.div`
	color: grey;
	.dot {
		height: 7px;
		width: 7px;
		margin-right: 0.2rem;
		background-color: #bbb;
		border-radius: 50%;
		display: inline-block;
		vertical-align: middle;
	}
`;

const InfoContainer = styled.div`
	margin: auto;
	margin-top: 1.4rem;
	padding: 0px;
	position: relative;
	text-align: center;
	max-width: 22rem;
	overflow: hidden;
`;

const TotalPrice = styled.h4`
	font-size: 2.7em;
	padding: 0;
	margin-top: -1rem;
`;

const Header = styled.h3`
	margin: auto;
	text-align: center;
	margin-top: 4rem;
	font-size: 3.6rem;
`;

const Confirmation = styled.div`
	padding: 0;
	margin-top: -1.2rem;
	margin-bottom: -0.4rem;
`;

const ConfirmedPurchase = styled.div`
	margin: auto;
	max-width: 50rem;
	border: 2px solid #93cb13;
	padding: 0.2rem;
	margin-top: 1rem;
	margin-bottom: 1.5rem;
	text-align: left;
`;

const IconContainer = styled.div`
	float: left; /* add this */
	padding: 1rem;
`;

const TextContainer = styled.div`
	overflow: hidden;
`;

const OrderNotice = styled.div`
	width: 70%;
	min-width: 300px;
	margin: auto;
	border: 2px solid red;
	color: red;
	font-size: 1rem;
	padding: 1rem;
	margin-top: 2rem;
`;

const voices = [0, 300, 600, 1200];
const datas = [5, 10, Infinity];
const dataString = {
	5: '5gt',
	10: '10gt',
	Infinity: 'Rajaton data'
};
const dataNumber = {
	'5gt': 5,
	'10gt': 10,
	unlimited: Infinity
};
const prices = [
	{ 5: 5, 10: 8, Infinity: 15 }, // voice 0
	{ 5: 11, 10: 14, Infinity: 19 }, // voice 300
	{ 5: 14, 10: 17, Infinity: 21 }, // voice 600
	{ 5: 19, 10: 21, Infinity: 24 } // voice 1200
];

export class B2bOrderPage extends React.PureComponent {
	// eslint-disable-line react/prefer-stateless-function
	constructor() {
		super();
		this.state = {
			value: 0,
			data: null,
			voice: 0,
			submitted: false,
			modalIsOpen: false,
			showOfferingChangeView: true
		};
	}

	UNSAFE_componentWillMount() {
		const { fetchSims, fetchCurrentOrder, fetchCustomerData, customer } = this.props;
		fetchSims(getAccountId());
		fetchCurrentOrder(getAccountId());
		if (!customer) {
			fetchCustomerData();
		}
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// this.state.data is null when entering page and state values need to be populated with current order when available
		if (this.state.data === null && nextProps.currentOrder !== null) {
			const data = dataNumber[nextProps.currentOrder.dataPerSim];
			const voice = voices.indexOf(nextProps.currentOrder.moisPerSim);
			this.setMatrixState(data, voice);
		}
	}

	setMatrixState = (data, voice) => {
		const priceObject = prices[voice];
		this.setState({
			value: priceObject[data],
			voice: voices[voice],
			data: data
		});
	};

	getCurrentOrderPricePerSim = () => {
		const data = dataNumber[this.props.currentOrder.dataPerSim];
		const voice = voices.indexOf(this.props.currentOrder.moisPerSim);
		const priceObject = prices[voice];
		return priceObject[data];
	};

	handleSubmit = () => {
		const { updateOrder } = this.props;
		updateOrder({
			dataPerSim: this.state.data === Infinity ? 'unlimited' : `${this.state.data}gt`,
			moisPerSim: this.state.voice
		});
		this.setState({
			submitted: true,
			modalIsOpen: false
		});
		gaB2BChangeOrder(Object.keys(this.props.sims).length, this.state.value - this.getCurrentOrderPricePerSim());
	};

	doOpenModal = () => {
		this.setState({
			modalIsOpen: true
		});
	};

	closeModal = () => {
		this.setState({
			modalIsOpen: false
		});
	};

	selectedNewOrderDisplayText = () => (this.state.data === Infinity ? 'Rajaton data' : this.state.data + 'gt') + ' ja ' + this.state.voice + 'min tai viestiä kuukaudessa per simmi';

	continueToCurrentOrder = () => {
		this.setState({
			showOfferingChangeView: false
		});
	};

	render() {
		const { sims, currentOrder, orderUpdateFinished, errors } = this.props;
		const noErrors = errors.length < 1;
		const ready = currentOrder !== null;

		if (this.state.showOfferingChangeView) {
			return <B2B2SalesArguments currentPrice={this.state.value} currentOrder={currentOrder} continueToCurrentOrder={this.continueToCurrentOrder} offeringType={this.props.offeringType} />;
		}

		return (
			<article>
				<Helmet title="Muokkaa tilausta" meta={[{ name: 'description', content: '' }]} />
				{ready && noErrors && (
					<div>
						<Header>Muokkaa sopimusta</Header>
						<Center>
							{noErrors && this.state.submitted && orderUpdateFinished && (
								<ConfirmedPurchase>
									<IconContainer>
										<Icon name="medium--ok" />
									</IconContainer>
									<TextContainer>
										<p>Sopimus on päivitetty. Valitsemasi sopimus ja hinta astuvat voimaan heti.</p>
									</TextContainer>
								</ConfirmedPurchase>
							)}
							<div>
								<Matrix
									handlerFromParent={this.setMatrixState}
									currentData={currentOrder.dataPerSim}
									currentVoice={currentOrder.moisPerSim}
									voices={voices}
									datas={datas}
									dataString={dataString}
									dataNumber={dataNumber}
									prices={prices}
								/>
							</div>
						</Center>
						<Center>
							{!this.state.submitted && sims !== null && (
								<div>
									<h4 id="confirm-header">Vahvista uusi tilaus</h4>
									<p>{`${Object.keys(sims).length} liittymää yhteensä [a ' ${this.state.value} €/kk]`}</p>
									<TotalPrice>{`${this.state.value * Object.keys(sims).length} €/kk`}</TotalPrice>
									<Confirmation>
										<Button
											className="mini"
											onClick={this.doOpenModal}
											disabled={_.isEmpty(sims) || (dataNumber[currentOrder.dataPerSim] === this.state.data && currentOrder.moisPerSim === this.state.voice)}
										>
											Vahvista uusi tilaus
										</Button>
									</Confirmation>
									<Link to="/account/dashboard">
										<Button className="mini invisible">Enpäs</Button>
									</Link>
								</div>
							)}
							<Row>
								<Column className="large-centered columns">
									<InfoContainer>
										<div>
											<SquareRed />
											<Container>
												<LegendItem id="info">
													Valitsemasi hinta ja sopimus astuvat voimaan heti.
													{!(dataNumber[currentOrder.dataPerSim] === this.state.data && currentOrder.moisPerSim === this.state.voice) && (
														<GreyText>
															{' '}
															<div className="dot" /> {this.selectedNewOrderDisplayText()}
														</GreyText>
													)}
												</LegendItem>
											</Container>
											<SquareGrey />
											<Container>
												<LegendItem className="legendItem">
													Voimassa oleva sopimus
													<GreyText>
														{' '}
														<div className="dot" /> {currentOrder.dataPerSim === 'unlimited' ? 'Rajaton data' : currentOrder.dataPerSim} ja {currentOrder.moisPerSim} min tai viestiä kuukaudessa per
														simmi
													</GreyText>
												</LegendItem>
											</Container>
										</div>
									</InfoContainer>
								</Column>
							</Row>
						</Center>
						{_.isEmpty(sims) && !this.state.submitted && (
							<div>
								<Header>Laske hinta ja tilaa Moi-liittymät</Header>
								<OrderNotice>Käytössäsi ei ole vielä laskutettavia liittymiä. Ota liittymiä käyttöön muokataksesi tilausta.</OrderNotice>
							</div>
						)}
						<ConfirmModal
							isOpen={this.state.modalIsOpen}
							onRequestClose={this.closeModal}
							onConfirm={this.handleSubmit}
							message={this.selectedNewOrderDisplayText()}
							title={'Vahvista tilauksen muutos'}
						/>
					</div>
				)}
				{!noErrors && <Error message={'Jotain meni vikaan. Yritä myöhemmin uudestaan tai ota yhteyttä asiakaspalveluumme'} />}
			</article>
		);
	}
}

B2bOrderPage.propTypes = {
	errors: PropTypes.array,
	fetchSims: PropTypes.func,
	sims: PropTypes.array,
	updateOrder: PropTypes.func,
	customer: PropTypes.object,
	currentOrder: PropTypes.object,
	orderUpdateFinished: PropTypes.bool,
	fetchCurrentOrder: PropTypes.func,
	fetchCustomerData: PropTypes.func,
	offeringType: PropTypes.string
};

const mapStateToProps = createStructuredSelector({
	errors: selectErrors,
	fetching: makeSelectFetching(),
	sims: makeSelectSims(),
	currentOrder: makeSelectCurrentOrder(),
	orderUpdateFinished: makeSelectUpdateOrderFinished(),
	customer: selectCustomerData
});

const mapDispatchToProps = {
	...globalActions,
	...simActions,
	...customerActions
};

export default connect(mapStateToProps, mapDispatchToProps)(B2bOrderPage);
